import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { images } from "../data/business";

export default function VisualBreak() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

    return (
        <section
            ref={ref}
            data-testid="visual-break"
            className="relative h-[75vh] min-h-[500px] overflow-hidden"
        >
            <motion.img
                src={images.break}
                alt="Trabalho real em unhas do Studio Danielly Sousa"
                loading="lazy"
                style={{ y }}
                className="absolute inset-0 h-[116%] w-full object-cover"
            />
            <div className="absolute inset-0 bg-ink/25" />
            <div className="relative flex h-full items-center justify-center px-6">
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    className="max-w-4xl text-center font-display text-3xl font-medium uppercase leading-[1.15] tracking-tight text-paper sm:text-5xl lg:text-6xl"
                >
                    Seu estilo.
                    <br />
                    <span className="italic">Sua escolha.</span>
                    <br />
                    <span className="text-accent">Nosso cuidado.</span>
                </motion.p>
            </div>
        </section>
    );
}
